import { IMemberContact } from './memberContact';
import { IMemberEmergencyContact } from './memberEmergencyContact';
import { IMemberFreezeDetail } from './memberFreezeDetail';
import { IMemberFeeDetails } from './feeDetail';
import { IFeeSubmissionDetail } from './feeSubmissionDetail';
import { IRegistrationDetail } from './RegistrationDetail';
import { IAttendance } from './attendance';
import { ISettings } from './settings';
import { Customerstrainer } from './Customerstrainer';

export class IRequest {
    _id: string;
    name: string;
    dateOfBirth: Date;
    email: string;
    gender: string;
    requestType:string;
    profile: string;
    requestDate: Date;
    requestStatus: string;
    isApproved: Boolean;
    isDelete: Boolean;
    requestId: string;
    memberId: string;
    tagNumber: string;
    noteDetails: string;
    joiningDate: Date;
    registerationFee: string;
    trainingFee: string;
    monthFee: string;
    feeDetails: IMemberFeeDetails[];
    attendance: IAttendance[];
    contactDetail: IMemberContact;
    freezeDetail: IMemberFreezeDetail;
    emergencyContact: IMemberEmergencyContact;
    customerstrainer: Customerstrainer;
    profession: string;
    question1: string;
    question2: string;
    question3: string;
    settings: ISettings;
    branch: string;
    company: string;
    biometricData: String;
    isBiometricVerified: boolean;
    packageType: String;
    packageId: String;
    cardNo: String;
    visitorFee: String;
    visitorType: string;
    customerPackageFee: number;
    packageLogo: string;
    feeSubmissionDetail: IFeeSubmissionDetail;
    registrationDetail: IRegistrationDetail;
}